import React, { useContext } from "react";
import { AppContext } from "../../../../../App";
import Can from "../../../../can/Can";
import NotFound from "../../../../notFound/NotFound";
import { users } from "../../../../../rbac-consts";
import ServiceDetailsContainer from "./ServiceDetailsContainer";

const ClientServicesDetailsWrapper = ({ match }) => {

  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={users.SUPER_ADMIN}
        yes={() => (
          <ServiceDetailsContainer match={match} />
        )}
        no={() => (
          <NotFound />
        )}
      />
    </>
  );
};

export default ClientServicesDetailsWrapper;
